module.exports = __webpack_public_path__ + "img/jia1.f5a1dc27.jpg";